const AlertIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_2314_19730)">
        <path
          fill="currentColor"
          d="m16.668 12.998-5.652-10.39c-.909-1.528-3.122-1.53-4.032 0l-5.651 10.39c-.929 1.563.195 3.54 2.015 3.54h11.304c1.818 0 2.944-1.976 2.016-3.54M9 14.664a.939.939 0 0 1 0-1.875.939.939 0 0 1 0 1.875m.938-3.75a.939.939 0 0 1-1.876 0V6.226a.939.939 0 0 1 1.876 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2314_19730">
          <path fill="currentColor" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertIcon;
